import { IfFeatureFlag } from '@ipfabric/ui-components/utils/featureFlags';
import { LocalUsersPage } from 'pages/Settings/Administration/LocalUsers/LocalUsersPage';
import { RolesPage } from 'pages/Settings/Administration/Roles/RolesPage';
import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { createTableApiScopeRequirement } from 'utils/rbac/helpers/createTableApiScopeRequirement';
import { DataPoliciesPage } from './DataPolicies/DataPoliciesPage';
import { EndpointPoliciesPage } from './EndpointPolicies/EndpointPoliciesPage';
import LdapSettingsPage from './LdapSettings';
import { PoliciesPage } from './Policies/PoliciesPage';
import { RolesPageV2 } from './Roles/RolesPageV2';

// Flags are only known after initial app data load, so gate at render time.
const withLabelsRbac = (enabled: ReactElement, disabled: ReactElement) => (
  <IfFeatureFlag flag='ENABLE_LABELS' enabled={enabled} disabled={disabled} />
);

const redirectToRoles = (
  <Navigate to='/settings/administration/roles' replace />
);

export const administrationRoutes: RoutesTreeItem[] = [
  {
    path: '/settings/administration/local-users',
    element: <LocalUsersPage />,
    requiredApiScope: createTableApiScopeRequirement('/tables/users'),
  },
  {
    path: '/settings/administration/ldap',
    element: <LdapSettingsPage />,
    children: [
      {
        path: ':configurationId',
        element: <LdapSettingsPage />,
        children: [
          {
            path: ':step',
            element: <LdapSettingsPage />,
          },
        ],
      },
    ],
    requiredApiScope: {
      method: 'GET',
      path: '/settings/ldap',
    },
  },
  {
    path: '/settings/administration/policies',
    element: <PoliciesPage />,
    requiredApiScope: createTableApiScopeRequirement('/tables/policies'),
  },
  {
    path: '/settings/administration/roles',
    element: withLabelsRbac(<RolesPageV2 />, <RolesPage />),
    requiredApiScope: createTableApiScopeRequirement('/tables/roles'),
  },
  {
    path: '/settings/administration/endpoint-policies',
    element: withLabelsRbac(<EndpointPoliciesPage />, redirectToRoles),
    requiredApiScope: { method: 'GET', path: '/endpoint-policies' },
  },
  {
    path: '/settings/administration/data-policies',
    element: withLabelsRbac(<DataPoliciesPage />, redirectToRoles),
    requiredApiScope: { method: 'GET', path: '/data-policies' },
  },
];
